var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"scroll-to-top button is-medium is-link is-light",on:{"click":_vm.scrollToTop}},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-up"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }